<template>
  <v-container :class="colorCuaderno" fill-height>
    <!-- barra -->
    <v-app-bar
      app
      absolute
      :color="colorCuaderno"
      elevation="3"
      height="56"
      extension-height="40px"
      scroll-target="#app-container"
    >
      <v-btn icon to="/">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title class="pl-0">
        {{ t.cuaderno.deOracion }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-model="showMenu" :close-on-content-click="false" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-card width="300px" class="pa-4 mb-0">
          <v-slider
            label="Tamaño letra"
            v-model="ucMddTam"
            min="1"
            max="5"
            step="1"
            tick-size="1"
          ></v-slider>
        </v-card>
      </v-menu>
      <!-- menu -->
      <v-dialog
        v-model="showDateDialog"
        persistent
        ref="dateDialog"
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>event</v-icon>
          </v-btn>
        </template>
        <v-date-picker
          v-model="fechaCalendario"
          :locale="userConfig.lng"
          :min="appContext.min"
          :max="appContext.max"
          no-title
        >
          <v-spacer></v-spacer>
          <v-btn text @click="showDateDialog = false">Cancel</v-btn>
          <v-btn text color="primary" @click="goDay()">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-app-bar>

    <!-- contenido -->
    <v-content class="zoom">
      <div
        v-touch="{
          left: () => $emit('siguiente'),
          right: () => $emit('anterior')
        }"
      >
        <!-- full -->
        <v-row>
          <v-container class="zoom">
            <!-- Voz de la Misericordia -->
            <v-row class="d-flex justify-space-between px-3 overline">
              <span class="font-weight-bold flex-shrink-0 flex-grow-1">
                {{ t.cuaderno.vdlm }}
              </span>
              <span
                class="flex-shrink-1 flex-grow-0 font-weight-bold"
                :class="colorName + '--text text--darken-3'"
              >
                {{ t.dias.hoy }}
              </span>
            </v-row>
            <v-row>
              <v-col class="display-1 font-weight-thin">
                {{ userNote.vdm }}
              </v-col>
            </v-row>

            <!-- oracion personal -->
            <v-row>
              <v-col class="pb-0 overline font-weight-bold">
                {{ t.cuaderno.tuOraPerson }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ userNote.ora }}
              </v-col>
            </v-row>

            <!-- compromiso personal -->
            <v-row>
              <v-col class="pb-0 overline font-weight-bold">
                {{ t.cuaderno.tuCompromHoy }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="flex-grow-1 flex-shrink-0">
                {{ userNote.com }}
              </v-col>
              <v-col class="flex-grow-0 flex-shrink-1">
                <v-btn icon @click="toggleCompromiso()">
                  <v-icon>{{ iconoCompromiso }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-row>

        <!-- selector time -->
        <v-dialog v-model="showTime" persistent width="275px">
          <v-time-picker
            v-if="showTime"
            full-width
            v-model="alm"
            ampm-in-title
            :color="colorName + ' darken-1'"
          >
            <v-row align="center" class="px-2">
              <v-col>
                <v-btn icon @click="removeTime()">
                  <v-icon :color="colorName + ' darken-3'">alarm_off</v-icon>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-btn
                text
                :color="colorName + ' darken-3'"
                @click="showTime = false"
              >
                {{ t.app.cancelar }}
              </v-btn>
              <v-btn text :color="colorName + ' darken-3'" @click="saveTime()">
                OK
              </v-btn>
            </v-row>
          </v-time-picker>
        </v-dialog>
      </div>
    </v-content>
  </v-container>
</template>

<script>
import userConfigEdit from "../../mixs/mixUserConfigEdit";
import userColor from "../../mixs/mixUserColor";
import store from "../../store/_store";
import infoo from "../../plugins/infoo";

import { Touch } from "vuetify/lib/directives";

export default {
  name: "mdd-cuaderno-dia",
  mixins: [userColor, userConfigEdit],
  directives: { touch: Touch },
  beforeRouteUpdate(to, from, next) {
    // TODO: cambiar esta referencia directa
    // context.min se calcula de la fecha minima de la version del libro
    let hoy = infoo.hoy;
    let params = to.params;

    let dateMin = store.state.app.context.min || hoy.min; // fecha en formato iso
    let dateMax = store.state.app.context.max;
    let dateTo = infoo.fechaAMD(params.anio, params.mes, params.dia).iso;

    if (dateTo < dateMin) {
      dateMin = infoo.fechaIso(dateMin);
      params.dia = dateMin.dia;
      params.mes = dateMin.mes;
      params.anio = dateMin.anio;
      store.dispatch("lectio/load", params);
      next({ name: "MddLecturasBiblicas", params: params });
      return;
    }

    if (dateTo > dateMax) {
      dateMax = infoo.fechaIso(dateMax);
      params.dia = dateMax.dia;
      params.mes = dateMax.mes;
      params.anio = dateMax.anio;
      store.dispatch("lectio/load", params);
      next({ name: "MddLecturasBiblicas", params: params });
      return;
    }

    // al terminar la validacion carga
    store.dispatch("lectio/load", params);
    next();
  },
  mounted() {
    this.fechaCalendario = this.infoFecha.iso;
  },
  data() {
    return {
      showDateDialog: false,
      fechaCalendario: "",
      showMenu: false
    };
  },
  computed: {
    appContext() {
      return this.$store.getters["app/context"];
    },
    infoFecha() {
      let p = this.$route.params;
      return infoo.fechaAMD(p.anio, p.mes, p.dia);
    },
    nextDay() {
      let unDiaMas = this.infoFecha.fecha.getTime() + 24 * 60 * 60 * 1000;
      return infoo.fechaTime(unDiaMas);
    },
    nombreDia() {
      return this.t.dias[this.infoFecha.diaSem];
    },
    nombreMes() {
      return " " + this.t.meses[this.infoFecha.mes];
    },
    userNote() {
      return this.$store.getters["user/notes/item"](this.infoFecha.iso);
    },
    prevDay() {
      let unDiaMenos = this.infoFecha.fecha.getTime() - 24 * 60 * 60 * 1000;
      return infoo.fechaTime(unDiaMenos);
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    },
    tieneTxts() {
      return this.nota && this.nota.txts ? this.nota.txts.length > 0 : false;
    },
    txtSubrayados() {
      return this.nota.txts ? this.nota.txts : [];
    }
  },
  methods: {
    goDay() {
      this.showDateDialog = false;
      var fecha = infoo.fechaIso(this.fechaCalendario);
      if (this.fechaCalendario === this.docId) {
        return;
      }

      let params = {
        anio: fecha.anio,
        mes: fecha.mes,
        dia: fecha.dia,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };
      this.$router
        .push({ name: "MddLecturasBiblicas", params: params })
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            e: e,
            line: 197,
            src: "mdd-portada-libro"
          });
        });
    },
    goNextDay() {
      if (this.nextDay.iso > this.appContext.max) {
        return;
      }
      this.fechaCalendario = this.nextDay.iso;

      let params = {
        anio: this.nextDay.anio,
        mes: this.nextDay.mes,
        dia: this.nextDay.dia,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };
      this.$router
        .push({ name: "MddLecturasBiblicas", params: params })
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            e: e,
            line: 197,
            src: "mdd-portada-libro"
          });
        });
    },
    goPrevDay() {
      if (this.prevDay.iso < this.appContext.min) {
        return;
      }
      this.fechaCalendario = this.prevDay.iso;

      let params = {
        anio: this.prevDay.anio,
        mes: this.prevDay.mes,
        dia: this.prevDay.dia,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };
      this.$router
        .push({ name: "MddLecturasBiblicas", params: params })
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            e: e,
            line: 197,
            src: "mdd-portada-libro"
          });
        });
    }
  }
};
</script>
